import { MembersManagementContainer, MembersManagementContextProvider } from 'src/containers/Escrow/Members';
import { useSoftwareEscrow } from 'src/context/software-escrow';
import { EscrowPartyTypeEnum } from 'src/graphql/schema';

const SoftwareEscrowOnboardingMembers = () => {
  const {
    softwareEscrow: { currentCompanyRole, [currentCompanyRole as EscrowPartyTypeEnum]: party },
  } = useSoftwareEscrow();

  return (
    <MembersManagementContextProvider escrowPartyId={party!.id} canCreateMember={party!.policy.createEscrowMembers}>
      <MembersManagementContainer
        noteText={`By default, the escrow creator and account owner have Manager permissions. You'll need to grant other team members access before they can contribute. If a team member isn't listed, add them to your organization first.\nYou can manage members anytime.`}
      />
    </MembersManagementContextProvider>
  );
};

export default SoftwareEscrowOnboardingMembers;
